import { call, put, select, takeLatest } from "redux-saga/effects";
import { selectToken } from "../../../../../../redux-store/selectors";
import { updateWorkingHoursScheduleNameAction } from "../../../../constants/actions";
import {
  updateWorkingHoursScheduleName,
  updateWorkingHoursScheduleNameSuccess,
  updateWorkingHoursScheduleNameFailure,
} from "../../../actions/Manager/Settings/workingHoursActions";
import { notify } from "react-notify-toast";
import { updateWorkingHoursScheduleNameApi } from "../../../../axios/Manager";
import { union } from "ts-action";
import { WorkingHoursSchedule } from "../../../../../../types";
import { AxiosResponse } from "axios";
import { translate } from "../../../../../../helpers/translate";
import Strings from "../../../../i18n/strings/brandOpeningHours";

const t = translate("brandOpeningHours");
const actionTypes = union({ updateWorkingHoursScheduleName });
export function* updateWorkingHoursScheduleNameSaga({
  payload,
}: typeof actionTypes) {
  try {
    const token = yield select(selectToken);
    const { scheduleId, data } = payload;
    const response: AxiosResponse<WorkingHoursSchedule> = yield call(
      updateWorkingHoursScheduleNameApi,
      token,
      scheduleId,
      data
    );

    yield put(updateWorkingHoursScheduleNameSuccess(response.data));
    notify.show(
      t(Strings.workingHoursScheduleNameUpdatedSuccessfully),
      "success"
    );
  } catch (error) {
    yield put(updateWorkingHoursScheduleNameFailure(error as Error));
    notify.show(t(Strings.somethingWentWrong), "error");
  }
}

export function* watchUpdateWorkingHoursScheduleName() {
  yield takeLatest(
    updateWorkingHoursScheduleNameAction.requested,
    updateWorkingHoursScheduleNameSaga
  );
}
